export abstract class Namespace<T> {

    public constructor( public readonly key: string ) {  }

    public abstract get(): T | string;

    public abstract set(data: T): any;

}
